/** Entrées sidebar — `ready` = écran branché. Le reste = préparation (comme Devis). */
import type { ComponentType } from "react";
import {
  IconCatalog,
  IconClients,
  IconCredits,
  IconDashboard,
  IconEinvoice,
  IconInvoices,
  IconPayments,
  IconQuotes,
  IconRecurring,
  IconReports,
  IconSettings,
} from "../components/NavIcons";
import type { AppPage } from "../types";

export type NavId =
  | "dashboard"
  | "clients"
  | "catalog"
  | "quotes"
  | "invoices"
  | "recurring"
  | "credits"
  | "payments"
  | "reports"
  | "einvoice"
  | "settings";

export type NavEntry =
  | { kind: "sep"; id: string }
  | {
      kind: "item";
      id: NavId;
      label: string;
      hint: string;
      ready: boolean;
      page?: AppPage;
      Icon: ComponentType<{ className?: string }>;
    };

export const NAV: NavEntry[] = [
  {
    kind: "item",
    id: "dashboard",
    label: "Tableau de bord",
    hint: "Tableau de bord",
    ready: true,
    page: "dashboard",
    Icon: IconDashboard,
  },
  { kind: "sep", id: "sep-tiers" },
  { kind: "item", id: "clients", label: "Clients", hint: "Clients", ready: true, page: "clients", Icon: IconClients },
  { kind: "item", id: "catalog", label: "Catalogue", hint: "Catalogue", ready: true, page: "catalog", Icon: IconCatalog },
  { kind: "sep", id: "sep-pieces" },
  { kind: "item", id: "quotes", label: "Devis", hint: "Devis", ready: true, page: "quotes", Icon: IconQuotes },
  { kind: "item", id: "invoices", label: "Factures", hint: "Factures", ready: true, page: "invoices", Icon: IconInvoices },
  { kind: "item", id: "recurring", label: "Récurrentes", hint: "Factures récurrentes", ready: true, page: "recurring", Icon: IconRecurring },
  { kind: "item", id: "credits", label: "Avoirs", hint: "Avoirs", ready: true, page: "credits", Icon: IconCredits },
  { kind: "sep", id: "sep-suivi" },
  { kind: "item", id: "payments", label: "Paiements", hint: "Paiements", ready: true, page: "payments", Icon: IconPayments },
  { kind: "item", id: "reports", label: "Rapports", hint: "Rapports", ready: true, page: "reports", Icon: IconReports },
  {
    kind: "item",
    id: "einvoice",
    label: "Électronique",
    hint: "Envoi électronique (maquette)",
    ready: true,
    page: "einvoice",
    Icon: IconEinvoice,
  },
  { kind: "item", id: "settings", label: "Paramètres", hint: "Paramètres", ready: true, page: "settings", Icon: IconSettings },
];
